export const LOAD_PRODUTOS_CATEGORIAS = "LOAD_PRODUTOS_CATEGORIAS";
export const SET_PAGE_PRODUTOS_CATEGORIA = "SET_PAGE_PRODUTOS_CATEGORIA";
export const SET_PERPAGE_PRODUTOS_CATEGORIA = "SET_PERPAGE_PRODUTOS_CATEGORIA";
export const SET_TOTAL_PRODUTOS_CATEGORIA = "SET_TOTAL_PRODUTOS_CATEGORIA";
export const SET_PRODUTOS_CATEGORIA = "SET_PRODUTOS_CATEGORIA";
export const LOADING_PRODUTOS_CATEGORIA = "LOADING_PRODUTOS_CATEGORIA";
export const SET_FILTRO_PRODUTOS_CATEGORIA = "SET_FILTRO_PRODUTOS_CATEGORIA";
